export default __webpack_public_path__ + "static/media/timelineNoti.81e31887.svg";